import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import ModalWrapper from 'components/Modals/ModalWrapper';

class UpdateFormTypeModal extends Component {
  static propTypes = {
    isShown: PropTypes.bool.isRequired,
    isEditingFormType: PropTypes.bool,
    onSubmitNewFormType: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    formId: PropTypes.number.isRequired,
    originalFileName: PropTypes.string,
    otherFormTypesInFamily: PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
          id: PropTypes.number,
          description: PropTypes.string
        })
      ])
    )
  };

  static defaultProps = {
    isEditingFormType: false,
    originalFileName: '',
    otherFormTypesInFamily: {}
  };

  constructor() {
    super();
    this.state = { disableConfirmButton: true, modalSize: 'modal-allow-overflow', selectedFormTypeId: '' };
    this.setDisableConfirm = this.setDisableConfirm.bind(this);
    this.disableConfirm = this.disableConfirm.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isShown } = this.props;
    if (!prevProps.isShown && isShown) {
      this.setState({
        selectedFormTypeId: '',
        disableConfirmButton: true
      });
    }
  }

  onCloseModal(e) {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel(e);
    }
  }

  setDisableConfirm(val) {
    const { disableConfirmButton } = this.state;
    if (disableConfirmButton !== val) {
      this.setState({ disableConfirmButton: val });
    }
  }

  handleFormTypeChange = (e) => {
    const selectedFormTypeId = e.target.value;
    this.setState({ selectedFormTypeId });

    this.setDisableConfirm(selectedFormTypeId === '');
  };

  disableConfirm() {
    if (this.state) {
      const { disableConfirmButton } = this.state;
      return disableConfirmButton;
    }
    return true;
  }

  submitNewFormType(e, formId, newFormType) {
    this.setDisableConfirm(true);
    e.preventDefault();

    const { onSubmitNewFormType } = this.props;
    onSubmitNewFormType(formId, newFormType);
  }

  render() {
    const {
      isShown,
      isEditingFormType,
      formId,
      originalFileName,
      otherFormTypesInFamily
    } = this.props;
    const {
      modalSize,
      disableConfirmButton
    } = this.state;
    const { selectedFormTypeId } = this.state;
    return (
      <ModalWrapper
        headerClose={ false }
        isOpen={ isShown }
        title={ `Edit Form Type - ${ originalFileName }` }
        btnConfirmTitle="Submit"
        btnConfirmClass={ `btn-primary ${ isEditingFormType ? 'loading' : '' }` }
        btnCancelTitle="Close"
        onCancel={ e => this.onCloseModal(e) }
        disableConfirm={ () => disableConfirmButton }
        modalSize={ modalSize }
        formId="editFormType"
        useDummySubmit
      >
        <div className="edit-form-type-modal">
          <div className="form-group mt-2">
            <div className="col-3">
              <label
                htmlFor="select-new-form-type"
                className="form-label m-2 text-left"
              >
                New Form Type:
              </label>
            </div>
            <div className="col-8">
              <select
                id="select-new-form-type"
                name="new-form-type"
                className="form-input"
                value={ selectedFormTypeId }
                onChange={ this.handleFormTypeChange }
              >
                <option value="" disabled>Select a form type</option>
                {
                    Object.entries(otherFormTypesInFamily).map(([id, description]) => (
                      <option key={ id } value={ id }>{description}</option>
                    ))
                }
              </select>
            </div>
          </div>
          <div className="mt-3 edit-form-type-modal-notice">
            <p className="bold">⚠️ Important Notice</p>
            <p>
              Changing the version of a form may introduce additional fields that were not
              captured during OCR processing. Please <span className="bold">manually review the form</span> and ensure all required data is entered.
            </p>
          </div>
        </div>
        <button
          type="button"
          id="dummy-add-form-btn"
          className="hide"
          onClick={ e => this.submitNewFormType(e, formId, selectedFormTypeId) }
        >Submit</button>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    auth: {
      permissions
    }
  } = state;
  return {
    permissions
  };
};

export default connect(
  mapStateToProps
)(UpdateFormTypeModal);
